import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Food Blogger",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_111e29bbe-1763294966477.png",
    avatarAlt: "Professional headshot of Indian woman with long black hair, warm smile, wearing traditional earrings and modern casual attire",
    rating: 5,
    comment: "Taco Street has completely changed my perception of Mexican food in Bengaluru. The authenticity is unmatched, and knowing everything is halal certified gives me complete peace of mind. The street tacos are absolutely divine!",
    date: "November 2025"
  },
  {
    id: 2,
    name: "Ahmed Khan",
    role: "Tech Professional",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_112da7240-1763294160138.png",
    avatarAlt: "Professional headshot of young Indian man with short black hair, friendly smile, wearing blue casual shirt in office setting",
    rating: 5,
    comment: "As someone who's particular about halal food, Taco Street is a blessing. The quality is exceptional, the ambience is perfect for team lunches, and the service is always quick. The loaded nachos are my go-to order!",
    date: "November 2025"
  },
  {
    id: 3,
    name: "Sneha Reddy",
    role: "Student",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14e479cba-1763300676390.png",
    avatarAlt: "Cheerful young Indian woman with shoulder-length black hair, bright smile, wearing colorful casual top with modern accessories",
    rating: 5,
    comment: "The vibe at Taco Street is incredible! It's become our favorite hangout spot. The food is amazing, prices are student-friendly, and the staff makes you feel like family. The burrito bowls are huge and so flavorful!",
    date: "December 2025"
  },
  {
    id: 4,
    name: "Rahul Verma",
    role: "Entrepreneur",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17c989f9e-1763293351359.png",
    avatarAlt: "Professional headshot of Indian man with styled black hair, confident expression, wearing formal black blazer and white shirt",
    rating: 5,
    comment: "I've tried Mexican food in many cities, and Taco Street stands out for its authenticity and consistency. The fresh ingredients, bold flavors, and attention to detail make every visit memorable. Highly recommended!",
    date: "November 2025"
  }];


  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-accent/5 to-primary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real experiences from real food lovers who've discovered their new favorite spot
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-card rounded-2xl p-8 md:p-12 shadow-lg">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-primary/20">
                    <Image
                      src={testimonials?.[activeTestimonial]?.avatar}
                      alt={testimonials?.[activeTestimonial]?.avatarAlt}
                      className="w-full h-full object-cover" />

                  </div>
                  <div className="absolute -bottom-2 -right-2 w-12 h-12 rounded-full bg-primary flex items-center justify-center">
                    <Icon name="Quote" size={24} color="#FFFFFF" />
                  </div>
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(testimonials?.[activeTestimonial]?.rating)]?.map((_, index) =>
                  <Icon key={index} name="Star" size={20} color="#E59500" className="fill-current" />
                  )}
                </div>

                <p className="text-lg text-foreground mb-6 italic">
                  "{testimonials?.[activeTestimonial]?.comment}"
                </p>

                <div>
                  <h4 className="text-xl font-bold text-foreground">
                    {testimonials?.[activeTestimonial]?.name}
                  </h4>
                  <p className="text-muted-foreground">
                    {testimonials?.[activeTestimonial]?.role}
                  </p>
                  <p className="text-sm text-muted-foreground mt-1">
                    {testimonials?.[activeTestimonial]?.date}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="Previous testimonial">

            <Icon name="ChevronLeft" size={24} />
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="Next testimonial">

            <Icon name="ChevronRight" size={24} />
          </button>

          {/* Indicators */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials?.map((_, index) =>
            <button
              key={index}
              onClick={() => setActiveTestimonial(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === activeTestimonial ?
              'bg-primary w-8' : 'bg-muted hover:bg-muted-foreground'}`
              }
              aria-label={`Go to testimonial ${index + 1}`} />

            )}
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          {[
          { icon: "Users", value: "10,000+", label: "Happy Customers" },
          { icon: "Star", value: "4.8/5", label: "Average Rating" },
          { icon: "MapPin", value: "3", label: "Locations" },
          { icon: "Award", value: "100%", label: "Halal Certified" }]?.
          map((stat, index) =>
          <div key={index} className="text-center">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <Icon name={stat?.icon} size={32} color="var(--color-primary)" />
              </div>
              <div className="text-3xl font-bold text-foreground mb-2">
                {stat?.value}
              </div>
              <div className="text-muted-foreground">
                {stat?.label}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;